/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AddPersonRegular from './add-person-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AddPersonRegular {...validProps} />;
}
SvgComponent.iconName = 'addPersonRegular';

export const AddPersonRegularIcon = svgIconWrapper(SvgComponent);
